module.exports = [{ "name": "Revive Injured Person", "isTemporary": true, "experiencePoints": 1000, "workshopTypeId": "g2kN1zSxh0KKyQ5Z", "level": 1, "_id": "x0oYkYNe2gy0ue0Y", "activeTurns": 1, "cooldownTurns": 1, "totalUses": 1 }]
;